import {SearchSortType, SortType} from './search-types';
import {URL_QUERY_PARAM, URL_SORT_PARAM} from './const';

import {parseURI} from './search.utils';

export const parseSortFieldString = (sortFieldString: string, sortTypesFromConfiguration: SortType[] | undefined): SortType => {
    if (sortTypesFromConfiguration) {
        for (const sort of sortTypesFromConfiguration) {
            if (sortFieldString === sort.field) {
                return {field: sort.field, order: sort.order};
            }
        }
    } else {
        for (const type of SearchSortType.getAll()) {
            if (sortFieldString === type.field) {
                return {field: type.field, order: type.order};
            }
        }
    }
    return {field: SearchSortType.RELEVANCE.field, order: SearchSortType.RELEVANCE.order};
};

export const encodeSearchOrderString = (sortField?: string): string => {
    return sortField ? parseURI(URL_SORT_PARAM, sortField, false) : '';
};
export const encodeQueryString = (searchExpression?: string): string => {
    return searchExpression ? parseURI(URL_QUERY_PARAM, searchExpression) : '';
};
